import registrationMetadata from 'metadata/candidate_registration'

const metadata = {
  fields: [
    'id',
    'candidate_id',
    'updated_at',
    'created_by',
    'updated_by',
    'candidate_name',
    'application_id',
    'total_score',
    'tq',
    'skt_id',
    'evaluation_id',
    'is_attended',
    'is_eligible_for_result',
    'school_id',
    {
      evaluation: [
        'name',
        'id',
        'created_by',
        {
          paper: [
            'paper_id',
            'id',
            'paper_smart_id',
            { product: ['name', 'id', 'total_marks', 'tq', 'type'] },
            { test_event: ['name', 'id'] },
            { test_track: ['id', 'name'] },
          ],
        },
        { evaluation_request: ['id', 'name', 'request_id'] },
      ],
    },
  ],
}

//----------------------------------------(FOR CANDIDATE TABLE)---------------------------------------------------------
// const metadata = {
//   fields: [
//     'id',
//     'created_at',
//     'updated_at',
//     'created_by',
//     'updated_by',
//     'user_id',
//     'email_id',
//     'phone_number',
//     'username',
//     'first_name',
//     'last_name',
//     {
//       registrations: [
//         'id',
//         'created_by',
//         'created_at',
//         'test_event_id',
//         'test_track_id',
//         'paper_id',
//         'date',
//         'start_time',
//         'end_time',
//         { test_track: ['id', 'name'] },
//         { test_event: ['id', 'name'] },
//         { paper: ['id', 'paper_id', 'paper_smart_id'] },
//       ],
//     },
//   ],
// }

export default metadata
